import React, { useState, useEffect } from 'react';
import { useForm } from 'react-hook-form';
import useFetchWithMsal from '../../hooks/useFetchWithMsal';
import { protectedResources } from '../../authConfig';
import { IQuizQuestion } from '../../model/QuizQuestion.model';
import { IQuizQuestionAnswer } from '../../model/QuizQuestionAnswer.model';
import Modal from '../Modal/Modal';
import { useMsal } from '@azure/msal-react';
import { Icon } from '../icons/icons';
import "./EditQuizComponent.scss";

const EditQuizComponent: React.FC = () => {
  const { instance } = useMsal();
  const [account, setAccount] = useState(instance.getActiveAccount());
  const { register, handleSubmit, reset } = useForm();
  const { error, execute } = useFetchWithMsal({
    scopes: protectedResources.apiCFSkillPath.scopes.write,
  });
  const [loading, setLoading] = useState(false);
  const [callErr, setErr] = useState(null);
  const [questions, setQuestions] = useState<IQuizQuestion[]>([]);
  const [currentQuestion, setCurrentQuestion] = useState<IQuizQuestion | null>(null);
  const [addingQuestion, setAddingQuestion] = useState(false);
  const [updatingQuestion, setUpdatingQuestion] = useState<IQuizQuestion | null>(null);
  const [addingAnswer, setAddingAnswer] = useState<IQuizQuestion | null>(null);
  const [updatingAnswer, setUpdatingAnswer] = useState<IQuizQuestionAnswer | null>(null);

  useEffect(() => {
    getQuizQuestions();
  }, []);

  const getQuizQuestions = () => {
    if (questions.length) return;
    setLoading(true);
    execute('GET', '/api/QuizQuestionsAnswers')
      .then((response) => {
        if (response.error) {
          return;
        }
        setQuestions(response);
        setLoading(false);
      })
      .catch((err) => {
        setErr(err);
        setLoading(false);
      });
  };
  if (account && (account as any).accessToken && !loading) {
    getQuizQuestions();
  } else if (account && !loading) {
    getQuizQuestions();
  }

  const addNewQuestion = (data: any) => {
    setLoading(true);
    var indexNumber = questions.reduce((a, b) => { if (b.indexNumber > a) return b.indexNumber; return a }, 0);
    data.indexNumber = indexNumber + 1;
    execute('POST', '/api/QuizQuestion/add', data)
      .then((response) => {
        if (response.error) {
          return;
        }
        setQuestions([...questions, response]);
        setLoading(false);
        setAddingQuestion(false);
      })
      .catch((err) => {
        setErr(err);
        setLoading(false);
      });
  };

  const updateQuestion = (data: any) => {
    updatingQuestion!.question = data.question;
    setLoading(true);
    execute('PUT', `/api/QuizQuestion/update`, updatingQuestion as any)
      .then((response) => {
        if (response.error) {
          return;
        }
        let quest = questions.find(q => q.quizQuestionId === response.quizQuestionId);
        if (quest) quest.question = response.question;
        setQuestions(questions);
        setLoading(false);
        setUpdatingQuestion(null);
      })
      .catch((err) => {
        setErr(err);
        setLoading(false);
      });
  };

  const deleteQuestion = (id: string) => {
    setLoading(true);
    execute('DELETE', `/api/QuizQuestion/delete/${id}`)
      .then((response) => {
        if (response.error) {
          return;
        }
        setQuestions(questions.filter(q => q.quizQuestionId !== id));
        setLoading(false);
      })
      .catch((err) => {
        setErr(err);
        setLoading(false);
      });
  };

  const addNewAnswer = (data: any) => {
    if (questions === undefined || !data) return;
    setLoading(true);
    let addNewAnswer: IQuizQuestionAnswer = { ...data, quizQuestionId: addingAnswer?.quizQuestionId };
    //@ts-ignore
    addNewAnswer.indexNumber = questions?.find((x: any) => x.quizQuestionId === addingAnswer?.quizQuestionId).answers?.length + 1;
    addNewAnswer.genericweight = 0;

    execute('POST', '/api/QuizQuestionAnswer/add', addNewAnswer)
      .then((response) => {
        if (!response || response.error) {
          debugger;
          return;
        }
        questions.find((q: any) => q.quizQuestionId === response.quizQuestionId)?.answers?.push(response);
        //setQuestions(questions.map(q => q.quizQuestionId === addingAnswer?.quizQuestionId ? { ...q, answers: [...q.answers, response] } : q));
        setLoading(false);
        setAddingAnswer(null);
      })
      .catch((err) => {
        setErr(err);
        setLoading(false);
      });
  };

  const updateAnswer = (data: any) => {
    setLoading(true);
    let answer = updatingAnswer;
    if (!answer) {
      alert('no answer found');
      return;
    }
    answer.answer = data.answer;
    answer.pmweight = data.pmweight;
    answer.lweight = data.lweight;
    answer.smeweight = data.smeweight;
    //debugger;
    //return;
    execute('PUT', `/api/QuizQuestionAnswer/update`, answer)
      .then((response) => {
        if (response.error) {
          return;
        }
        answer = response;
        /*
        setQuestions(questions.map(q => q.quizQuestionId === updatingAnswer?.quizQuestionId ? {
          ...q,
          answers: q.answers.map(a => a.quizQuestionAnswerId === response.quizQuestionAnswerId ? response : a)
        } : q));*/
        setLoading(false);
        setUpdatingAnswer(null);
      })
      .catch((err) => {
        setErr(err);
        setLoading(false);
      });
  };

  const deleteAnswer = (questionId: string, answerId: string) => {
    setLoading(true);
    execute('DELETE', `/api/QuizQuestionAnswer/delete/${answerId}`)
      .then((response) => {
        if (response.error) {
          return;
        }
        /*
        setQuestions(questions.map(q => q.quizQuestionId === questionId ? {
          ...q,
          answers: q.answers.filter(a => a.quizQuestionAnswerId !== answerId)
        } : q));*/
        setLoading(false);
      })
      .catch((err) => {
        setErr(err);
        setLoading(false);
      });
  };

  const setUpdatingQuestionAndReset = (question: IQuizQuestion) => {
    setUpdatingQuestion(question);
    reset({ "question": question.question });
  }
  const setAddingQuestionAndReset = () => {
    setAddingQuestion(true);
    reset({ "question": "" });
  }
  const setAddingAnswerAndReset = (question: IQuizQuestion) => {
    setAddingAnswer(question);
    reset({ 'answer': "", 'lweight': 0, 'pmweight': 0, 'smeweight': 0, 'genericweight': 0 });
  }
  const setUpdatingAnswerAndReset = (answer: IQuizQuestionAnswer) => {
    setUpdatingAnswer(answer);
    reset({
      'answer': answer.answer,
      'lweight': answer.lweight,
      'pmweight': answer.pmweight,
      'smeweight': answer.smeweight
    });
  }

  const CancelAllEditing = () => {
    setAddingAnswer(null);
    setAddingQuestion(false);
    setUpdatingAnswer(null);
    setUpdatingQuestion(null);
  }

  return (
    <div className="max-width edit-quiz-component">
      <h2 className='h1-size'>Edit Quiz Questions</h2>
      <div className='aln-center m-b-2'>
        <button className='btn-secondary' onClick={() => setAddingQuestionAndReset()}>Add New Question</button>
      </div>

      <ol>
        {questions.map((question) => (
          <li className='m-b-1-75' key={question.quizQuestionId}>
            <b>{question.question}</b>
            <div className='m-l-1 dis-inline-flex gap--50'>
              <button title='Edit question' className='btn-icon' onClick={() => setUpdatingQuestionAndReset(question)}>
                <Icon name='icon-pencil' className='icon-secondary' />
              </button>
              <button title='Delete question' className='btn-icon' disabled onClick={() => deleteQuestion(question.quizQuestionId)}>
                <Icon name="icon-trash-no-circle" className='icon-secondary' />
              </button>
              <button title="Add answer" className='btn-icon' onClick={() => setAddingAnswerAndReset(question)}>
                <Icon name="icon-plus" className='icon-secondary' />
              </button>
            </div>

            <ul className='m-t--50'>
              {question.answers && question.answers.map((answer) => (
                <li className='dis-flex p-t--50 p-b--50' key={answer.quizQuestionAnswerId}>
                  {answer.answer}
                  <div className='m-l--50 dis-flex gap--50'>
                    <button title='Edit answer' className='btn-icon' onClick={() => setUpdatingAnswerAndReset(answer)}>
                      <Icon name='icon-pencil' className='icon-secondary' />
                    </button>
                    <button title='Delete answer' className='btn-icon' disabled onClick={() => deleteAnswer(question.quizQuestionId, answer.quizQuestionAnswerId)}>
                      <Icon name="icon-trash-no-circle" className='icon-secondary' />
                    </button>
                  </div>
                </li>
              ))}
            </ul>
          </li>
        ))}
      </ol>

      {addingQuestion && (
        <Modal modalTitle='Add New Question' isOpen={addingQuestion} onClose={CancelAllEditing}>
          <form onSubmit={handleSubmit(addNewQuestion)}>
            <div className="modal-form-content-scroll-container">
              <div className="form-group">
                <label htmlFor="question">Question</label>
                <textarea id="question" className='no-resize' rows={3} {...register('question', { required: true })} />
              </div>
            </div>
            <div className="modal-form-button-container two-button">
              <button className='btn-med-gray' type="button" onClick={() => setAddingQuestion(false)}>Cancel</button>
              <button className='btn-secondary' type="submit">Add</button>
            </div>
          </form>
        </Modal>
      )}

      {updatingQuestion && (
        <Modal modalTitle='Update Question' isOpen={updatingQuestion !== null} onClose={CancelAllEditing}>
          <form onSubmit={handleSubmit(updateQuestion)}>
            <div className="modal-form-content-scroll-container">
              <div className="form-group">
                <label htmlFor="question">Question</label>
                <textarea id="question" className='no-resize' rows={3} defaultValue={updatingQuestion.question} {...register('question', { required: true })} />
              </div>
            </div>
            <div className="modal-form-button-container two-button">
              <button className='btn-med-gray' type="button" onClick={() => setUpdatingQuestion(null)}>Cancel</button>
              <button className='btn-secondary' type="submit">Update</button>
            </div>
          </form>
        </Modal>
      )}

      {addingAnswer && (
        <Modal modalTitle='Add Answer' isOpen={addingAnswer !== null} onClose={CancelAllEditing}>
          <form onSubmit={handleSubmit(addNewAnswer)}>
            <div className="modal-form-content-scroll-container">
              <div className="form-group m-b-1">
                <label htmlFor="answer" className='edit-quiz-component-form-label'>Question</label>
                <textarea id="answer" className='no-resize' rows={3} {...register('answer', { required: true })} />
              </div>
              <div className="form-group m-b-1">
                <label htmlFor='leader' className='edit-quiz-component-form-label'>Leader Weight</label>
                <input id="leader" type="number" {...register('lweight')} />
              </div>
              <div className="form-group m-b-1">
                <label htmlFor='pm' className='edit-quiz-component-form-label'>PM Weight</label>
                <input id="pm" type="number" {...register('pmweight')} />
              </div>
              <div className="form-group">
                <label htmlFor='sme' className='edit-quiz-component-form-label'>PM Weight</label>
                <input id="sme" type="number" {...register('smeweight')} />
              </div>
            </div>
            <div className="modal-form-button-container two-button">
              <button className='btn-med-gray' type="button" onClick={() => setAddingAnswer(null)}>Cancel</button>
              <button className='btn-secondary' type="submit">Add</button>
            </div>
          </form>
        </Modal>
      )}

      {updatingAnswer && (
        <Modal modalTitle='Update Answer' isOpen={updatingAnswer !== null} onClose={CancelAllEditing}>
          <form onSubmit={handleSubmit(updateAnswer)}>
            <div className="modal-form-content-scroll-container">
              <div className="form-group m-b-1">
                <label htmlFor='answer' className='edit-quiz-component-form-label'>Answer</label>
                <textarea className='no-resize' rows={3} id="answer" defaultValue={updatingAnswer.answer} {...register('answer', { required: true })} />
              </div>
              <div className="form-group m-b-1">
                <label htmlFor='leader' className='edit-quiz-component-form-label'>Leader Weight</label>
                <input id="leader" type="number" defaultValue={updatingAnswer.lweight} {...register('lweight')} /><br />
              </div>
              <div className="form-group m-b-1">
                <label htmlFor='pm' className='edit-quiz-component-form-label'>PM Weight</label>
                <input id='pm' type="number" defaultValue={updatingAnswer.pmweight} {...register('pmweight')} />
              </div>
              <div className="form-group">
                <label htmlFor='sme' className='edit-quiz-component-form-label'>SME Weight</label>
                <input id='sme' type="number" defaultValue={updatingAnswer.smeweight} {...register('smeweight')} />
              </div>
            </div>
            <div className="modal-form-button-container two-button">
              <button className='btn-med-gray' type="button" onClick={() => setUpdatingAnswer(null)}>Cancel</button>
              <button className='btn-secondary' type="submit">Update</button>
            </div>
          </form>
        </Modal>
      )}
    </div>
  );
};

export default EditQuizComponent;